<script setup>
import { cn } from '@/lib/utils'
import { inject, onMounted, ref, watch } from 'vue'

const props = defineProps({
  class: { type: String, default: '' },
  src: { type: String, required: true },
  alt: { type: String, default: '' },
})

const imageLoadingStatus = inject('imageLoadingStatus', ref('idle'))
const hasLoaded = ref(false)

const handleLoad = () => {
  hasLoaded.value = true
  imageLoadingStatus.value = 'loaded'
}

const handleError = () => {
  hasLoaded.value = false
  imageLoadingStatus.value = 'error'
}

onMounted(() => {
  imageLoadingStatus.value = 'loading'
})

watch(() => props.src, () => {
  hasLoaded.value = false
  imageLoadingStatus.value = 'loading'
})
</script>

<template>
  <img
    v-if="imageLoadingStatus === 'loading' || imageLoadingStatus === 'loaded'"
    :src="src"
    :alt="alt"
    :class="cn('aspect-square h-full w-full', props.class)"
    @load="handleLoad"
    @error="handleError"
  />
</template>
